export default "__VITE_ASSET__BB3MRMbn__"